var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 62C0.25 96.2417 28.0083 124 62.25 124C96.4917 124 124.25 96.2417 124.25 62C124.25 27.7583 96.4917 0 62.25 0C28.0083 0 0.25 27.7583 0.25 62Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.25 62C93.25 44.95 79.3 31 62.25 31C45.2 31 31.25 44.95 31.25 62C31.25 77.5 42.4875 90.2875 57.2125 92.6125V70.9125H49.4625V62H57.2125V55.025C57.2125 47.275 61.8625 43.0125 68.8375 43.0125C72.325 43.0125 75.8125 43.7875 75.8125 43.7875V51.5375H71.9375C68.0625 51.5375 66.9 53.8625 66.9 56.1875V62H75.425L73.875 70.9125H66.5125V93C82.0125 90.675 93.25 77.5 93.25 62Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.97a37d6cc453cff0c4c2cb543abac48c.svg";
export { ForwardRef as ReactComponent };